export enum PathType {
  UNDEFINED = '',
  ANIMAL_HEALTH = 'SA',
  PROTECTION_JURIDIQUE = 'PJ',

  CONFORT = 'HC',
  SOLIDAIRE = 'HS',
  MARSEILLE = 'HA',
  GRENOBLE = 'HG',
  ETUDIANT = 'HE',
  PARIS = 'HP',
  LILLE = 'HL',
  CRETEIL = 'HR',
  TOURCOING = 'HT',
  BAILLEUR_SOCIAL = 'BS',
  ESSENTIELLE = 'HN',

  MOBILITE_ECO_ACTIVE = 'ME',
}

export const isPathType = (pathType: string | null): pathType is PathType => {
  switch (pathType) {
    case PathType.ANIMAL_HEALTH:
    case PathType.PROTECTION_JURIDIQUE:
    case PathType.MOBILITE_ECO_ACTIVE:
      return true;
    default:
      return false;
  }
};

export enum LongPathTypeName {
  MARSEILLE = 'Marseille',
  GRENOBLE = 'Grenoble Alpes Métropole',
  PARIS = 'Paris',
  LILLE = 'Lille, Lomme et Hellemmes',
  CRETEIL = 'Créteil',
  TOURCOING = 'Tourcoing',
  CONFORT = 'Confort',
  SOLIDAIRE = 'Solidaire',
  ETUDIANT = 'Etudiant',
  BAILLEUR_SOCIAL = 'Bailleur social',
  MOBILITE_ECO_ACTIVE = 'Mobilité éco-active',
}

export enum PathName {
  MARSEILLE = 'Marseillaise',
  GRENOBLE = 'Grenoble Alpes Métropole',
  PARIS = 'Parisienne',
  LILLE = 'Lilloise',
  CRETEIL = 'Cristolienne',
  TOURCOING = 'Tourquennoise',
  CONFORT = 'Confort',
  CONFORT_PLUS = 'ConfortPlus',
  SOLIDAIRE = 'Solidaire',
  ETUDIANT = 'Etudiant',
  BAILLEUR_SOCIAL = 'Bailleurs_Sociaux',
  ESSENTIELLE = 'Essentielle',
  MOBILITE_ECO_ACTIVE = 'mobilite-eco-active',
}

//? Mostly used for dispatching data to store (fetch devis and policy from backend)
export enum PathCode {
  CON = 'CON',
  SOL = 'SOL',
  CONP = 'CON+',
  TOU = 'TOU',
  LIL = 'LIL',
  PAR = 'PAR',
  GRE = 'GRE',
  CRE = 'CRE',
  ETU = 'ETU',
  MAR = 'MAR',
  PAR2 = 'PAR2',
  TOU2 = 'TOU2',
  LIL2 = 'LIL2',
  SOL2 = 'SOL2',
  BSOL = 'BSOL',
  CON2 = 'CON2',
  CONP2 = 'CON+2',
  ESS = 'ESS',
  MEA = 'MEA',
}
